import { generate } from 'random-words';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const newWordOfTheDay = generate({ exactly: 1, minLength: 5, maxLength: 8 })[0];

root.render(
  <React.StrictMode>
    <App initialState={{ newWordOfTheDay }}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
